let faceList = [
  '开心', //  1
  '大笑', //  2
  '龇牙', //  3
  '挤眉弄眼', //  4
  '尬笑', //  5
  '笑哭', //  6
  '可爱', //  7
  '微笑', //  8
  '眨眼微笑', //  9
  '色', //  10
  '爱你', //  11
  '亲亲', //  12
  '吐舌', //  13
  '鬼脸', //  14
  '疑惑', //  15
  '老花镜', //  16
  '酷', //  17
  '满眼放光', //  18
  '尴尬', //  19
  '叹息', //  20
  '忧伤', //  21
  '痛苦', //  22
  '挣扎', //  23
  '大哭', //  24
  '怄气', //  25
  '不悦', //  26
  '生气', //  27
  '口吐芬芳', //  28
  '目瞪口呆', //  29
  '吃惊', //  30
  '汗', //  31
  '思考', //  32
  '嘘', //  33
  '骗人', //  34
  '面无表情', //  35
  '惊吓', //  36
  '赞叹', //  37
  '伤心', //  38
  '瞌睡', //  39
  '睡着', //  40
  '馋', //  41
  '闭嘴', //  42
  '瞎', //  43
  '吐', //  44
  '感冒', //  45
  '口罩', //  46
  '发烧', //  47
  '受伤', //  48
  '财迷', //  49
  '牛仔', //  50
  '小丑', //  51
  '恶魔', //  52
  '屎', //  53
  '骷髅', //  54
  '爆发', //  55
  '加油', //  56
  'ok', //  57
  '点赞', //  58
  '鼓掌' //  59
]

export default faceList



//////////////////
// WEBPACK FOOTER
// ./utils/faceList.js
// module id = null
// module chunks = 